/**
 * Dynamic loader for Yandex Maps JS API 3.0 (ymaps3).
 *
 * Singleton pattern: the script is loaded once, subsequent calls
 * return the cached promise.
 */
// Access the global via window to avoid TypeScript narrowing issues
// with `typeof ymaps3` guards (the global is declared as `const`, not `var`).
function getGlobalApi() {
    return window.ymaps3;
}
let loadPromise = null;
export function loadYmaps3() {
    if (loadPromise)
        return loadPromise;
    loadPromise = new Promise((resolve, reject) => {
        // If already loaded (e.g. via <script> tag)
        const existing = getGlobalApi();
        if (existing) {
            existing.ready.then(() => resolve(existing)).catch(reject);
            return;
        }
        const apiKey = process.env.REACT_APP_YANDEX_MAPS_API_KEY || "";
        if (!apiKey) {
            console.error("[ymaps3Loader] REACT_APP_YANDEX_MAPS_API_KEY is not set. " +
                "Yandex Maps will not load. Add the key to .env.development");
        }
        const script = document.createElement("script");
        script.src = `https://api-maps.yandex.ru/v3/?apikey=${apiKey}&lang=ru_RU`;
        script.async = true;
        script.onload = () => {
            const api = getGlobalApi();
            if (!api) {
                reject(new Error("[ymaps3Loader] ymaps3 is not defined after script load"));
                return;
            }
            api.ready.then(() => resolve(api)).catch(reject);
        };
        script.onerror = () => {
            loadPromise = null; // Allow retry
            reject(new Error("[ymaps3Loader] Failed to load Yandex Maps script"));
        };
        document.head.appendChild(script);
    });
    return loadPromise;
}
